var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:['legal', _vm.$route.params.legal]},[_c('article',[_c('AppHeadline',{staticClass:"legal__title",attrs:{"data":{
        content: _vm.legal[_vm.$route.params.legal].title,
        type: 2,
      }}}),_vm._l((_vm.legal[_vm.$route.params.legal].sections),function(section,i){return _c('section',{key:i},[_c('AppHeadline',{staticClass:"section__title",attrs:{"data":{
          content: section.title,
          type: 3,
        }}}),_c('AppParagraph',{attrs:{"data":{
          content: section.content,
        }}})],1)})],2),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }